import styled from "styled-components";

export const ModalContainer = styled.div`
  width: 100%;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.5);
  overflow: hidden;
  max-height: 90dvh;
  overflow-y: auto;
  max-width: fit-content;
  border-radius: 24px;
  border: 1px solid #142743;
  background: #0a1424;
  position: relative;
  z-index: 1000;
`;

export const ModalTitle = styled.h2`
  color: #fff;
  font-family: Figtree;
  font-size: 18px;

  font-weight: 600;

  letter-spacing: -0.09px;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  position: relative;
`;

export const CloseButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  color: #fff;

  &:hover {
    opacity: 0.7;
  }
`;

export const ModalContent = styled.div`
  padding: 16px;

  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  text-align: center;
`;

export const ModalMessage = styled.p`
  color: #fff;
  text-align: left;
  font-family: Figtree;
  font-size: 15px;
  opacity: 0.4;
  font-weight: 400;
  line-height: 20px; /* 133.333% */
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 8px;
  justify-content: center;
  flex-direction: column;
  width: 100%;
`;

export const Label = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 12px;
  font-weight: 400;
  letter-spacing: -0.06px;
`;
export const Column = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 4px;
  align-items: flex-start;
`;
export const AspectRations = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  width: 100%;
  overflow-x: auto;
  scrollbar-width: none;
`;

export const Image = styled.img`
  height: auto;
  width: 100%;
  border-radius: 12px;
`;
export const AspectRationButton = styled.button`
  display: flex;
  height: 32px;
  padding: 6px 16px;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  gap: 4px;
  outline: none;

  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  line-height: 18px; /* 128.571% */
  letter-spacing: -0.07px;

  border-radius: 8px;
  border: 1px solid #345884;
  background: ${(p) => (p.$active ? "#345884" : "#112238")};
`;
export const CancelButton = styled.button`
  display: flex;
  width: 100%;

  height: 20px;
  padding: 0 20px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  /* border-radius: 100px; */
  background: transparent;
  border: none;
  outline: none;

  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
  cursor: pointer;
  transition: all 0.3s ease;

  /* &:hover:not(:disabled) {
    background: rgba(255, 255, 255, 0.05);
    border-color: rgba(255, 255, 255, 0.4);
  } */

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const ConfirmButton = styled.button`
  display: flex;

  width: 100%;
  height: 40px;
  padding: 0 20px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 100px;
  background: ${({ $type }) => {
    switch ($type) {
      case "danger":
        return "linear-gradient(135deg, #ff4757, #ff3838)";
      case "success":
        return "linear-gradient(135deg, #2877D9, #c4057a)";
      case "primary":
      default:
        return "#fff";
    }
  }};
  border: none;
  outline: none;

  color: ${({ $type }) => ($type === "primary" ? "#081120" : "#ffffff")};
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
  white-space: nowrap;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: ${({ $type }) => {
      switch ($type) {
        case "danger":
          return "0 4px 15px rgba(255, 71, 87, 0.3)";
        case "success":
          return "0 4px 15px rgba(163, 0, 94, 0.3)";
        case "primary":
        default:
          return "0 4px 15px rgba(0, 0, 0, 0.1)";
      }
    }};
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    pointer-events: none;
  }
`;

export const CropContainer = styled.div`
  width: 100%;
  max-width: 600px;
  position: relative;

  .ReactCrop {
    max-height: 400px;
  }
`;

export const ZoomSlider = styled.input.attrs((props) => ({
  "data-value": props.value,
  "data-min": props.min,
  "data-max": props.max,
}))`
  appearance: none;
  width: 100%;
  height: 10px;
  border: 0.5px solid #325682;
  border-radius: 12px;
  background: ${(props) => {
    const percentage =
      ((props.value - props.min) / (props.max - props.min)) * 100;
    return `linear-gradient(90deg, #366db1 ${percentage}%, #142743 ${percentage}%)`;
  }};
  cursor: pointer;

  /* Thumb: for Chrome, Safari, Edge */
  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 15px;
    height: 15px;
    border-radius: 100px;
    background: #ffffff;
    box-shadow: none;

    &:hover {
      transform: scale(1.1);
      box-shadow: 0 2px 8px rgba(54, 109, 177, 0.4);
    }
  }

  /* Thumb: for Firefox */
  &:-moz-range-thumb {
    border: none;
    width: 15px;
    height: 15px;
    border-radius: 100px;
    background: #ffffff;
    box-shadow: none;
  }
`;
